import React, { useMemo } from "react";
import { Quizzes } from "../../components/Quiz";
import { useQuizContext } from "../../context/QuizContext";
import { useStreamContext } from "../../context/StreamContext";
import './style.scss';

export default ({ block }) => {
    const className = "quizzes-block";
    const { quizzes } = useQuizContext();
    const { stream } = useStreamContext();
    const quizzesSettings = block.quizzes;

    const viewQuizzes = useMemo(() => {
        if (!quizzesSettings || !quizzes || !quizzesSettings.length || !quizzes.length) {
            return [];
        }

        const quizzesSettingsFilter = quizzesSettings.filter(quiz =>
            !stream || quiz.showInStreams?.includes(stream.id)
        );

        return quizzesSettingsFilter
            .sort((a, b) => a.order - b.order)
            .reduce((acc, quiz) => {
                const currentQuiz = quizzes.find((item) => item.id === quiz.id) || {};

                acc.push({
                    ...currentQuiz,
                    ...quiz,
                    displaySize: currentQuiz?.displaySize ?? 1,
                });

                return acc;
            }, []);
    }, [quizzes, quizzesSettings, stream]);

    return (
        <section className={`page-block ${className}`}>
            <Quizzes quizzes={viewQuizzes} />
        </section>
    );
};
